import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { Check } from 'lucide-react';
export function IncludesSection() {
  const items = ['Un marco simple para entender la culpa espiritual (y desactivarla).', 'Qué hacer cuando rezás y no sentís nada (sequedad) sin pensar que fracasaste.', 'Guión de 7 minutos de mañana (oración mixta: hablar con Dios + tradicional).', 'Guión de 7 minutos de noche con examen breve (sin auto-castigo).', 'Guión de 3 minutos de emergencia para días caóticos.', 'Plan de Rescate 24h: volvés hoy, no “el lunes”.', 'Calendario de 21 días con foco diario + 1 cita breve por día.', 'Guía suave para integrar Misa y Confesión sin presión ni vergüenza.', 'Cómo sostenerlo si tenés ansiedad o ruido mental (ancla + vuelta).'];
  return <section className="py-20 px-6 md:px-8 max-w-2xl mx-auto" data-id="element-103">
      <AnimatedSection data-id="element-104">
        <h2 className="text-3xl md:text-4xl font-serif text-bark mb-10 text-center" data-id="element-105">
          ¿Qué incluye exactamente <br data-id="element-106" />
          “Devoción sin Culpa”?
        </h2>

        <p className="text-lg text-bark/80 mb-8 text-center" data-id="element-107">
          Dentro del PDF tenés:
        </p>

        <ul className="space-y-4" data-id="element-108">
          {items.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-109">
              <span className="mt-1 text-gold flex-shrink-0" data-id="element-110">
                <Check size={20} strokeWidth={3} data-id="element-111" />
              </span>
              <span className="text-lg text-bark/90" data-id="element-112">{item}</span>
            </li>)}
        </ul>
      </AnimatedSection>
    </section>;
}